<template>
  <div class="dashboard-guarantorinfo-block" v-if="guarantorLoaded">
    <Tabs class="" :animated="false" style="height:100%">
      <TabPane label="保证人信息" name="guarantor">
        <div class="tab-content" :style="{height:tabContentHeight+'px'}">
          <vue-scroll>
            <table class="brief-table" v-if="guarantorModel&&guarantorModel.name">
              <tbody>
                <tr>
                  <td class="title">保证人名称</td>
                  <td colspan="3">
                    {{guarantorModel.name}}
                    <Tag v-if="guarantorModel.status!==null"
                      :color="$common.guarantorStatusColor[guarantorModel.status.toString()]">
                      {{$common.guarantorStatus[guarantorModel.status.toString()]}}
                    </Tag>
                  </td>
                  <td class="title">保证人类型</td>
                  <td>{{guarantorModel.type!==null ? $common.guarantorType[guarantorModel.type.toString()] : ''}}</td>
                </tr>
                <tr>
                  <td class="title">机构代码</td>
                  <td>{{guarantorModel.code||'未设置'}}</td>
                  <td class="title">审核人</td>
                  <td>{{guarantorModel.auditorName}}</td>
                  <td class="title">审核时间</td>
                  <td>{{guarantorModel.auditTime?require('moment')(guarantorModel.auditTime).format('YYYY-MM-DD HH:mm:ss'):null}}</td>
                </tr>
                <tr v-if="guarantorModel.comment">
                  <td class="title">审核意见</td>
                  <td colspan="5">{{guarantorModel.comment}}</td>
                </tr>
                <tr>
                  <td class="title">社会信用代码</td>
                  <td>{{guarantorModel.businessLicense}}</td>
                  <td class="title">注册资金(万元)</td>
                  <td>{{guarantorModel.capital}}</td>
                  <td class="title">成立日期</td>
                  <td>{{guarantorModel.estDate?require('moment')(guarantorModel.estDate).format('YYYY-MM-DD'):null}}</td>
                </tr>
                <tr>
                  <td class="title">营业地址</td>
                  <td colspan="3">{{guarantorModel.address}}</td>
                  <td class="title">邮编</td>
                  <td>{{guarantorModel.postCode}}</td>
                </tr>
                <tr v-if="guarantorModel.scope">
                  <td class="title">营业范围</td>
                  <td colspan="5">{{guarantorModel.scope}}</td>
                </tr>
                <tr>
                  <td class="title">公司网址</td>
                  <td colspan="3">{{guarantorModel.homePage}}</td>
                  <td class="title">Email</td>
                  <td>{{guarantorModel.email}}</td>
                </tr>
                <tr>
                  <td class="title">联系人</td>
                  <td>{{guarantorModel.contact}}</td>
                  <td class="title">电话</td>
                  <td>{{guarantorModel.contactTel}}</td>
                  <td class="title">传真</td>
                  <td>{{guarantorModel.fax}}</td>
                </tr>
                <tr>
                  <td class="title">法定代表人</td>
                  <td>{{guarantorModel.legalPersonName}}</td>
                  <td class="title">职务</td>
                  <td>{{guarantorModel.legalPersonRole}}</td>
                  <td class="title">职称</td>
                  <td>{{guarantorModel.legalPersonTitle}}</td>
                </tr>
                <tr>
                  <td class="title">总经理</td>
                  <td>{{guarantorModel.generalManagerName}}</td>
                  <td class="title">职务</td>
                  <td>{{guarantorModel.generalManagerRole}}</td>
                  <td class="title">职称</td>
                  <td>{{guarantorModel.generalManagerTitle}}</td>
                </tr>
                <tr>
                  <td class="title">员工总数</td>
                  <td>{{guarantorModel.employeeTotal}}</td>
                  <td class="title">有职称</td>
                  <td>{{guarantorModel.titledTotal}}</td>
                  <td class="title">中高级职称</td>
                  <td>{{(guarantorModel.titledMedTotal||0)+(guarantorModel.titledSeniorTotal||0)}}</td>
                </tr>
                <tr>
                  <td class="title">注册监理工程师</td>
                  <td>{{guarantorModel.regSupervTotal}}</td>
                  <td class="title">注册建造师</td>
                  <td>{{guarantorModel.regConstrTotal}}</td>
                  <td class="title">注册造价师</td>
                  <td>{{guarantorModel.regCostTotal}}</td>
                </tr>
                <tr>
                  <td class="title">项目经理</td>
                  <td>{{guarantorModel.prjManagerTotal}}</td>
                  <td class="title">注册会计师</td>
                  <td>{{guarantorModel.cpaTotal}}</td>
                  <td class="title">律师</td>
                  <td>{{guarantorModel.solicitorTotal}}</td>
                </tr>
                <tr v-if="guarantorModel.guarRange">
                  <td class="title">担保经营范围</td>
                  <td colspan="6">{{guarantorModel.guarRange}}</td>
                </tr>
                <tr v-if="guarantorModel.introduction">
                  <td class="title" colspan="6">企业简介</td>
                </tr>
                <tr v-if="guarantorModel.introduction">
                  <td colspan="6">{{guarantorModel.introduction}}</td>
                </tr>
              </tbody>
            </table>
          </vue-scroll>
        </div>
      </TabPane>
    </Tabs>
  </div>
</template>

<script>
export default {
  components: {
  },
  data () {
    return {
      tabContentHeight: null,
      guarantorModel: null,
    }
  },
  computed: {
    guarantorLoaded () {
      return this.$store.getters.guarantorInfo
        && this.$store.getters.guarantorInfo.name
    },
  },
  watch: {
    '$store.getters.guarantorInfo': function (newVal) {
      if (newVal && newVal.name) {
        this.guarantorModel = newVal
      }
    },
    '$store.getters.screenHeight': function () {
      this.calcTabContentHeight()
    },
    '$store.getters.screenWidth': function () {
      this.calcTabContentHeight()
    }
  },
  mounted () {
    if (this.$store.getters.guarantorInfo && this.$store.getters.guarantorInfo.name) {
      this.guarantorModel = this.$store.getters.guarantorInfo
      this.calcTabContentHeight()
    }
  },
  methods: {
    calcTabContentHeight () {
      if (!document.querySelector('.dashboard-guarantorinfo-block')) {
        return false
      }
      let blockHeight = document.querySelector('.dashboard-guarantorinfo-block').clientHeight
      this.tabContentHeight = blockHeight - 36 - 16 // 减去ivu-tab-bar高度和margin
      // console.log(blockHeight, this.tabContentHeight)
    },
  }
}
</script>

<style lang="less" scoped>

.tab-content {
  overflow: hidden;
}
.dashboard-guarantorinfo-block {
  position: relative;
  height: 100%;
}
</style>